import { render } from "./FechaEfectoAsisaSalud.vue?vue&type=template&id=d4b0019a&scoped=true"
import script from "./FechaEfectoAsisaSalud.vue?vue&type=script&lang=js"
export * from "./FechaEfectoAsisaSalud.vue?vue&type=script&lang=js"

import "./FechaEfectoAsisaSalud.vue?vue&type=style&index=0&id=d4b0019a&scoped=true&lang=css"

import exportComponent from "/Users/anfloman/Desktop/ComponentesAlgoritmica/TemaWordpress/tema/vuejs/QuoteAndBuy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4b0019a"]])

export default __exports__